import { initContract } from '@ts-rest/core'

import { endUser } from './end-users/end-user.contract'
import { endUserPublic } from './end-users/end-user-public.contract'
import { endUsersContract } from './end-users/end-users.contract'
import { dashboardContract } from './dashboard/dashboard.contract'
import { campaign } from './campaign/campaign.contract'
import { customer } from './customer/customer.contract'
import { incentive } from './incentive/incentive.contract'
import { skuCode } from './sku-code/sku-code.contract'
import { holiday } from './agenda/holiday.contract'
import { intersolve } from './integrations/intersolve/intersolve.contract'
import { intersolveClassic } from './integrations/intersolve-classic/intersolve-classic.contract'
import { endUsersIntegrations } from './integrations/end-users-integrations.contract'
import { admin } from './admin/admin.contract'
import { playground } from './playground/playground.contract'
import { user } from './user/user.contract'

const c = initContract()
export const contract = c.router({
  endUser,
  endUserPublic,
  endUsers: endUsersContract,
  dashboard: dashboardContract,
  campaign,
  customer,
  incentive,
  skuCode,
  holiday,
  intersolve,
  intersolveClassic,
  endUsersIntegrations,
  admin,
  playground,
  user,
})
